import React from "react";
import { Loader2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { fmtPrice } from "@/lib/stripe";
import { coinsExact, coinVars } from "@/lib/coins";

// Final coin total (price + sales tax) shown BEFORE any coins leave the wallet.
export const CoinQuoteBox = ({ quote, merchCents = 0, busy, onPay, testid = "coin-quote" }) => {
  const { t } = useTranslation();
  const coins = coinsExact(quote.digital_total_cents);
  const row = "flex justify-between py-0.5";
  return (
    <div className="rounded-xl p-3 text-sm" data-testid={testid} style={{ background: "var(--bg-subtle)", border: "1px solid var(--border-color)" }}>
      <div className={row} style={{ color: "var(--text-secondary)" }}>
        <span>{t("shipping.subtotal")}</span><span data-testid={`${testid}-subtotal`}>{fmtPrice(quote.subtotal_cents / 100)}</span>
      </div>
      <div className={row} style={{ color: "var(--text-secondary)" }}>
        <span>{t("shipping.tax")}</span><span data-testid={`${testid}-tax`}>{fmtPrice(quote.tax_cents / 100)}</span>
      </div>
      <div className={`${row} mt-1 pt-1 font-semibold`} style={{ color: "var(--text-primary)", borderTop: "1px solid var(--border-color)" }}>
        <span>{t("coins.quoteTotal")}</span>
        <span data-testid={`${testid}-total`}>{t("coins.perPrice", coinVars(coins))} ({fmtPrice(quote.digital_total_cents / 100)})</span>
      </div>
      {merchCents > 0 && (
        <p className="text-xs mt-2" style={{ color: "var(--text-secondary)" }} data-testid={`${testid}-card-rest`}>{t("coins.quoteCardRest", { amount: fmtPrice(merchCents / 100) })}</p>
      )}
      <button type="button" onClick={onPay} disabled={busy} data-testid={`${testid}-pay`}
        className="w-full mt-3 py-3 rounded-full text-sm font-semibold flex items-center justify-center gap-2"
        style={{ background: "var(--accent-primary)", color: "#fff", opacity: busy ? 0.7 : 1 }}>
        {busy ? <Loader2 size={16} className="animate-spin" /> : t("coins.payExact", coinVars(coins))}
      </button>
    </div>
  );
};

export default CoinQuoteBox;
